export const addBusinessDays = (date: Date, daysToAdd: number): Date => {
  let daysRemaining = daysToAdd;

  const result = new Date(date.getTime());

  while (daysRemaining > 0) {
    result.setDate(result.getDate() + 1);
    if (result.getDay() !== 0 && result.getDay() !== 6) {
      daysRemaining--;
    }
  }

  return result;
};
